import { openBlock as l, createElementBlock as e, createElementVNode as t } from "vue";
function r(h, i) {
  return l(), e("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 512 512"
  }, [
    t("path", {
      style: { fill: "#FFDA44" },
      d: `M486.598,367.304C502.872,333.649,512,295.89,512,256s-9.128-77.649-25.402-111.304L256,133.565\r
	l-230.598,11.13C9.128,178.351,0,216.11,0,256s9.128,77.649,25.402,111.304L256,378.435L486.598,367.304z`
    }),
    t("path", { d: "M256,0C154.506,0,66.81,59.065,25.402,144.696h461.195C445.19,59.065,357.493,0,256,0z" }),
    t("path", {
      style: { fill: "#0052B4" },
      d: "M256,512c-101.494,0-189.19-59.065-230.598-144.696h461.195C445.19,452.935,357.493,512,256,512z"
    }),
    t("path", {
      style: { fill: "#A2001D" },
      d: `M499.911,178.087H12.089C4.247,202.656,0,228.831,0,256s4.247,53.344,12.089,77.913H499.91\r
	C507.753,309.344,512,283.169,512,256S507.753,202.656,499.911,178.087z`
    }),
    t("g", null, [
      t("rect", {
        x: "89.043",
        y: "244.87",
        style: { fill: "#FFDA44" },
        width: "333.913",
        height: "22.261"
      }),
      t("rect", {
        x: "133.565",
        y: "200.348",
        style: { fill: "#FFDA44" },
        width: "244.87",
        height: "22.261"
      })
    ]),
    t("path", {
      style: { fill: "#F0F0F0" },
      d: `M380.025,256c0,0-57.243,66.783-124.025,66.783S189.217,256,189.217,256s0-66.783,66.783-66.783\r
	S380.025,256,380.025,256z`
    }),
    t("path", { d: "M256,322.783c-66.783,0-124.025-66.783-124.025-66.783S189.217,189.217,256,189.217" }),
    t("rect", {
      x: "211.478",
      y: "233.739",
      style: { fill: "#F0F0F0" },
      width: "22.261",
      height: "44.522"
    }),
    t("rect", {
      x: "278.261",
      y: "233.739",
      width: "22.261",
      height: "44.522"
    }),
    t("g", null, [
      t("circle", {
        style: { fill: "#0052B4" },
        cx: "89.043",
        cy: "256",
        r: "22.261"
      }),
      t("circle", {
        style: { fill: "#0052B4" },
        cx: "422.957",
        cy: "256",
        r: "22.261"
      })
    ])
  ]);
}
export {
  r as default
};
